/*
 * @Author: shisan
 * @Date: 2019-07-11 20:03:52
 * @Last Modified by: shisan
 * @Last Modified time: 2020-01-16 15:25:02
 */
// import store from '../store'
import { isIphone, isAphone, isIpad } from '@/utils/mUtil'
// import { uuid4 } from './util'

export function commonParams() {
  const platform = isIphone()
    ? 'iphone'
    : isIpad()
    ? 'ipad'
    : isAphone()
    ? 'android'
    : ''
  let USERINFO = window.USERINFO || {}
  let DEVICEINFO = window.DEVICEINFO || {}

  return {
    uuid: USERINFO.uuid,
    uid: USERINFO.uuid,
    ticket: USERINFO.ticket,
    token: USERINFO.ticket,
    device: DEVICEINFO.device,
    did: DEVICEINFO.did,
    deviceId: DEVICEINFO.did,
    appVersion: DEVICEINFO.appVersion,
    osType: DEVICEINFO.osType,
    platform: platform,
    abroad: 0,
    aid: 635,
    // seqId: uuid4(),
  }
}

/**
 * 生成最终参数
 * @param {*} param
 */
export function getParams(param) {
  return Object.assign({}, commonParams(), param)
}
